/* NSI search overlay extras (30 Sep 2026, speed, Claude).
 *
 * "Top collections" and "Best sellers" used to be built into every page's header (about 146ms of
 * server time per fresh page). They now render only at /search?view=nsisearch
 * (snippets/nsi-search-extras.liquid) and this script drops them into [data-nsi-search-slot]
 * inside the overlay, exactly where they were, so the overlay looks the same.
 *
 * When: once the page has loaded and the browser is idle (all screen sizes), or straight away
 * when the search field, the search button or the phone search bar is touched. The HTML is kept
 * in sessionStorage for 30 minutes, so a visit fetches it once, not on every page. The cache key
 * carries the trade rate the header prints for signed-in trade members, so their prices never
 * come from a retail copy. If the fetch fails the overlay simply shows without the two blocks.
 * Rollback: site-speed-2026-09-30-round2/.
 */
(function () {
  var slot = document.querySelector('[data-nsi-search-slot]');
  if (!slot) return;
  var src = slot.getAttribute('data-nsi-search-src');
  var ls = document.querySelector('.live-search');
  var key = 'nsi-search-extras:v1:' + ((ls && ls.getAttribute('data-nsi-trade-rate')) || 'retail');
  var TTL = 30 * 60 * 1000;
  var loading = null;

  function insert(html) {
    if (!slot) return true;
    var tpl = document.createElement('template');
    tpl.innerHTML = html;                       // inert until inserted
    var box = tpl.content.querySelector('[data-nsi-search-deferred]');
    if (!box) return false;
    while (box.firstChild) slot.parentNode.insertBefore(box.firstChild, slot);
    slot.parentNode.removeChild(slot);
    slot = null;
    return true;
  }

  function cached() {
    try {
      var v = JSON.parse(sessionStorage.getItem(key) || 'null');
      if (v && v.html && (Date.now() - v.t) < TTL) return v.html;
    } catch (e) {}
    return null;
  }

  function load(lowPriority) {
    if (!slot) return Promise.resolve();
    var c = cached();
    if (c && insert(c)) return Promise.resolve();
    if (loading) return loading;
    var opts = { credentials: 'same-origin' };
    if (lowPriority) opts.priority = 'low';
    loading = fetch(src, opts)
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
      .then(function (html) {
        if (!slot) return;
        if (!insert(html)) throw new Error('no extras in response');
        try { sessionStorage.setItem(key, JSON.stringify({ t: Date.now(), html: html })); } catch (e) {}
      });
    loading.catch(function () { loading = null; });   // a later tap can retry
    return loading;
  }

  function warm() {
    var go = function () { load(true).catch(function () {}); };
    if (window.requestIdleCallback) window.requestIdleCallback(go, { timeout: 3000 });
    else setTimeout(go, 1200);
  }
  if (document.readyState === 'complete') warm();
  else window.addEventListener('load', warm);

  var TRIGGERS = '[data-search-toggle], [data-nsi-msearch], [data-nsi-msearch-drawer], [data-live-search-input]';
  document.addEventListener('pointerdown', function (e) {
    if (slot && e.target.closest && e.target.closest(TRIGGERS)) load(false).catch(function () {});
  }, { capture: true, passive: true });
  document.addEventListener('focusin', function (e) {
    if (slot && e.target.closest && e.target.closest('[data-live-search-input]')) load(false).catch(function () {});
  }, true);
})();
